<template>
  <div class="bp-card voice">
    <card-title title="语音播报" />
    <div class="metrics">
      <div class="metric">
        <span class="label">总播报数(条)</span>
        <span class="num total">{{ fmt(data.total) }}</span>
      </div>
      <div class="metric">
        <span class="label">已播报数(条)</span>
        <span class="num done">{{ fmt(data.done) }}</span>
      </div>
      <div class="metric">
        <span class="label">待播报数(条)</span>
        <span class="num pending">{{ fmt(data.pending) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import CardTitle from './CardTitle'
import { fmtNum } from '../format'

export default {
  name: 'BpVoiceBroadcast',
  components: { CardTitle },
  props: {
    // { total, done, pending }
    data: { type: Object, required: true }
  },
  methods: {
    fmt: fmtNum
  }
}
</script>

<style lang="less" scoped>
@import '../styles.less';
.voice {
  .metrics {
    display: flex;
    align-items: flex-end;
    margin-top: 30px;
    // 三项横向排列，与全宽卡左对齐分布
    .metric {
      display: flex;
      flex-direction: column;
      margin-right: 140px;
      .label {
        font-family: @font-cn;
        font-size: 16px;
        color: @bp-label;
        line-height: 1;
      }
      .num {
        margin-top: 8px;
        font-family: @font-num;
        font-weight: 700;
        font-size: 36px;
        line-height: 1;
        &.total { color: @bp-num; }
        &.done { color: @bp-blue; }
        &.pending { color: @bp-grey-blue; }
      }
    }
  }
}
</style>
